import React from "react";
import { motion } from "framer-motion";

// Scroll-triggered fade-up reveal wrapper.
const Reveal = ({ children, delay = 0, y = 30, className = "" }) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export default Reveal;
